import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../themes/common";

const INPUT_WIDTH = 22;
const INPUT_HEIGHT = 22;

const Input = styled.div``;

const radioLeftStyles = css`
    padding-left: 30px;
    &::before {
        left: 0;
    }
    &::after {
        left: 7px;
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 30px;
        &::before {
            left: auto;
            right: 0;
        }
        &::after {
            left: auto;
            right: 7px;
        }
    }
`;

const radioRightStyles = css`
    padding-right: 30px;
    &::before {
        right: 0;
    }
    &::after {
        right: 7px;
    }

    html[dir="rtl"] & {
        padding-left: 30px;
        padding-right: 0;
        &::before {
            left: 0;
            right: auto;
        }
        &::after {
            left: 7px;
            right: auto;
        }
    }
`;

export const Radio = styled(Input)<{ checked?: boolean; disabled?: boolean; radioRight?: boolean }>`
    position: relative;
    margin: 10px 0;
    transition: opacity 0.3s;
    cursor: pointer;
    opacity: ${({ disabled }) => (disabled ? 0.65 : 1)};

    &::before {
        position: absolute;
        top: 0;
        width: 20px;
        height: 20px;
        content: "";
        border: 1px solid ${({ theme }) => theme.color.grey2};
        border-radius: 50%;
    }

    &::after {
        display: ${({ checked }) => (checked ? "block" : "none")};
        position: absolute;
        top: 7px;
        width: 6px;
        height: 6px;
        content: "";
        background-color: ${({ theme }) => theme.color.dark};
        border-radius: 50%;
    }

    ${({ radioRight }) =>
        radioRight
            ? css`
                  @media ${getBreakpoint("down", "sm")} {
                      ${radioLeftStyles};
                  }
                  @media ${getBreakpoint("up", "sm")} {
                      ${radioRightStyles};
                  }
              `
            : radioLeftStyles};
`;

export const Label = styled.label`
    font-weight: 400;
    cursor: pointer;
`;

export const Checkbox = styled.label`
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 0;
    padding-left: 36px;
    font-family: ${({ theme }) => theme.fontFamily.regular};
    font-size: 1.7rem;
    line-height: 1.25;
    color: ${({ theme }) => theme.color.grey4};
    cursor: pointer;

    /* checkbox square */
    &::before {
        position: absolute;
        top: 0;
        left: 0;
        width: ${INPUT_WIDTH}px;
        height: ${INPUT_HEIGHT}px;
        content: "";
        background-color: ${({ theme }) => theme.color.lightest};
        border: 1px solid ${({ theme }) => theme.color.grey5};
        box-sizing: border-box;
    }

    html[dir="rtl"] & {
        padding-left: 0;
        padding-right: 36px;
        &::before {
            left: auto;
            right: 0;
        }
    }
`;

export const Wrapper = styled.div<SpaceProps>`
    ${space};

    input {
        display: none;
    }

    input:checked ~ ${Checkbox} {
        &::before {
            position: absolute;
            top: 0;
            left: 0;
            width: ${INPUT_WIDTH}px;
            height: ${INPUT_HEIGHT}px;
            content: "";
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='11' viewBox='0 0 13 11'%3E%3Cpath fill='%231A1A1A' fill-rule='evenodd' d='M3.45,10.25 L0.15,6.95 C-0.05,6.75 -0.05,6.45 0.15,6.25 C0.35,6.05 0.65,6.05 0.85,6.25 L3.45,8.85 C4.56430132,7.73569868 5.40002731,6.89997269 5.95717797,6.34282203 C6.21364152,6.08635848 6.49400218,5.80599782 6.79825994,5.50174006 C7.68385226,4.61614774 9.46776561,2.83223439 12.15,0.15 C12.35,-0.05 12.65,-0.05 12.85,0.15 C13.05,0.35 13.05,0.65 12.85,0.85 C10.5691363,3.13086374 8.85848846,4.84151154 7.71805659,5.98194341 C6.76959957,6.93040043 5.34691404,8.35308596 3.45,10.25 Z'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: center;
            border-color: ${({ theme }) => theme.color.dark};
        }
    }

    html[dir="rtl"] & {
        input:checked ~ ${Checkbox} {
            &::before {
                left: auto;
                right: 0;
            }
        }
    }
`;

export default Input;
